export default "__VITE_ASSET__BUfE0ViF__"